<template>
  <div>
    <validationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(addPurchase)">
        <b-row>
          <b-col md="12">
            <span>Purchase</span>
            <main-select
              v-model="selectedPurchase"
              :options="purchaseOptions"
              placeholder="--Select--"
            >
            <template #data="{data}">
              <span class="d-flex gap-2 m-0 p-0 justify-content-between">
                <span> {{ data.name }}</span>
                <span class="d-flex gap-1">
                  <span v-if="data.discount_price">({{  data.discount_price }}{{ data.currency }})</span>
                  <span :class="`${data.discount_price ? 'text-decoration-line-through' : ''}`">({{  data.price }}{{ data.currency }})</span>
                </span>
              </span>
            </template>
            <template #selected-option="{data}">
              <span>
                {{ data.name }} - <span v-if="data.discount_price">({{  data.discount_price }}{{ data.currency }})  </span>
                <span :class="`${data.discount_price ? 'text-decoration-line-through' : ''}`">({{  data.price }}{{ data.currency }})</span>
              </span>
            </template>
            </main-select>
          </b-col>

          <b-col md="12" class="quantity">
            <span>Quantity</span>
            <span class="btns">
              <button @click.prevent="purchase.quantity--" :disabled="purchase.quantity == 1">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33333 8H12.6667" stroke="#181836" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <span>{{ purchase.quantity }}</span>
              <button @click.prevent="purchase.quantity++">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 3.3335V12.6668" stroke="#181836" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3.33333 8H12.6667" stroke="#181836" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </span>
          </b-col>
          <b-col md="12" v-if="addOnsOptions.length">
            <span>Add-Ons (optional)</span>
            <main-select
              v-model="purchase.addOns"
              :options="addOnsOptions"
              label="key"
              multiple
              placeholder="--Select--"
            />
          </b-col>

          <b-col md="12">
            <span>Coupon (optional)</span>
           <main-select
              v-model="purchase.coupon"
              :options="couponOptions"
              label="discount_ratio"
              :clearable="true"
              placeholder="--Select--"
            >
             <template #data="{data}">
               <div class="d-flex gap-1">
                 <span class="font-weight-bold">{{ data.coupon?.discount_ratio }}%</span>
                 <span v-if="data.coupon?.applies_on">All {{ data.coupon?.applies_on }}</span>
                 <span v-else style="max-width: 100%;display: flex;flex-wrap: wrap; gap:2px">
                    <span v-for="(data, key) in getAppliedOnData(data.coupon)" :key="key">
                      <span v-if="key !== 0">,</span> {{ data }}
                    </span>
                 </span>
               </div>
             </template>
             <template #selected-option="{data}">
               <div class="d-flex gap-1">
                 <span class="font-weight-bold">{{ data.coupon?.discount_ratio }}%</span>
                 <span v-if="data.coupon?.applies_on">All {{ data.coupon?.applies_on }}</span>
                 <span v-else style="max-width: 100%;display: flex;flex-wrap: wrap; gap:2px">
                    <span v-for="(data, key) in getAppliedOnData(data.coupon)" :key="key">
                      <span v-if="key !== 0">,</span> {{ data }}
                    </span>
                 </span>
               </div>
             </template>

            </main-select>
          </b-col>
        </b-row>
        <!-- {{ purchaseOptions }} -->
        <div v-if="selectedPurchase">
          <h4>Purchase Invoice</h4>
          <div class="purchase-invoice">
            <div v-if="selectedPurchase" class="item">
              <span>
                <span class="number">{{ quantity }}</span>
                {{ selectedPurchase.name }}
              </span>
              <span class="number">+{{ purchase.quantity * selectedPurchase.discount_price ? selectedPurchase.discount_price :selectedPurchase.price }} EGP</span>
            </div>
            <template v-if="purchase.addOns">
              <div v-for="(item, index) in purchase.addOns" :key="index" class="item">
                <span>
                  <span class="number">{{ quantity }}</span>
                  {{ item.name }}
                </span>
                <span class="number">+{{ purchase.quantity * item.price }} EGP</span>
              </div>
            </template>
            <div v-if="purchase.coupon" class="item">
              <span class="coupon-text">Coupon Discount</span>
              <span class="number">-{{ couponAmount }} EGP</span>
            </div>

            <div class="item total">
              <span>Total Amount</span>
              <span class="number">{{ totalAmount - couponAmount }} EGP</span>
            </div>
          </div>
        </div>

        <b-row>
          <b-col md="12" class="mt-4">
            <div class="d-flex justify-content-center">
              <b-button class="button-orange-modal" type="submit" v-if="!requestLoading">
                <i class="las la-plus"></i>
              </b-button>
              <b-button class="button-orange-modal" v-else>
                <spinner-loading></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validationObserver>
  </div>
</template>
<script>
import ticketsServices from '@/modules/business/pricing/services/tickets.services'
import promotionsServices from '@/modules/business/pricing/services/promotions.services'
import couponsServices from '@/modules/business/pricing/services/coupons.services'
import giftServices from '@/modules/business/customers/services/management.services'
export default {
  props: {
    requestLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      purchase: {
        purchase: '',
        quantity: 1,
        addOns: [],
        coupon: '',
        user_id: this.$route.params.id,
        coupon_id: '',
        promotion_id: '',
        ticket_id: ''
      },
      selectedPurchase: null,
      purchaseOptions: [],
      addOnsOptions: [],
      couponOptions: []
    }
  },
  methods: {
    getAllTicketsLimit () {
      this.requestLoading = true
      ticketsServices.getAllTicketsLimit().then(res => {
        const tickets = res.data.data.data.map(item => ({
          ...item,
          type: 'ticket'
        }))

        this.purchaseOptions.push(...tickets)
      })
    },

    getAllPromotions () {
      this.requestLoading = true
      promotionsServices.getAllPromotionsList().then(res => {
        const promotions = res.data.data.current.map(item => ({
          ...item,
          type: 'promotion'
        }))

        this.purchaseOptions.push(...promotions)
      })
    },

    getAppliedOnData (data)  {
      return [...data.tickets.map(ticket => ticket.name),...data.promotions.map(promotion => promotion.name)]
    },

    getAllCoupons (payload) {
      giftServices.getCopounGift(this.$route.params.id, payload).then(res => {
        this.couponOptions = res.data?.data?.data
      })
    },

    getPurchaseOptions () {
      this.purchaseOptions = []
      this.getAllTicketsLimit()
      this.getAllPromotions()
    },
    buildPayload (data) {
      const payload = {
        user_id: data.user_id || null,
        quantity: data.quantity || 1,
        coupon_id: data.coupon_id || data.coupon?.coupon?.id || null,
        addons: (data.addOns || []).map(item => item.value) || []
      }
      if(this.selectedPurchase.type == 'ticket') {
        payload.ticket_id = this.selectedPurchase.id
      } else {
        payload.promotion_id = this.selectedPurchase.id
      }
      return payload
    },
    addPurchase () {
      // console.log(this.buildPayload(this.purchase))
      let obj = this.buildPayload(this.purchase)
      this.$emit('addPurchase', obj)
    }
  },
  watch: {
    selectedPurchase(val) {
      if(val.type == 'ticket') {
        console.log('val=> ', val)
        this.purchase.ticket_id = val.id
        this.addOnsOptions = val.addons || []
        this.addOnsOptions = val?.addons?.map(item => ({
          value: item.id,
          key: item.name,
          name: item.name,
          price: item.price
        }))
        console.log('addOnsOptions=> ', this.addOnsOptions)

        this.getAllCoupons({ type: 'ticket', ticket_id : val.id })
      } else {
        this.addOnsOptions = []
        this.purchase.promotion_id = val.id
        this.getAllCoupons({ type: 'promotion', promotion_id : val.id })
      }
    }
  },
  computed: {
    quantity () {
      return this.purchase.quantity > 1 ? `${this.purchase.quantity}x ` : ''
    },
    totalAmount () {
      let total = 0
      if (this.selectedPurchase) {
        if (this.selectedPurchase.discount_price) {
          total += this.selectedPurchase.discount_price * this.purchase.quantity
        } else {
          total += this.selectedPurchase.price * this.purchase.quantity
        }
      }
      if (this.purchase.addOns) {
        total += this.purchase.addOns.reduce((accumulator, currentValue) => {
          return accumulator + (currentValue.price * this.purchase.quantity)
        }, 0)
      }
      // if (this.purchase.coupon) total -= total * this.purchase.coupon.coupon * 0.01
      return total
    },
    couponAmount () {
      return this.purchase.coupon.discount_ratio ? this.totalAmount * this.purchase.coupon.discount_ratio * 0.01 : 0
    }
  },
  created () {
    this.getPurchaseOptions()
  }
}
</script>

<style lang="scss" scoped>
</style>
